/*
 * Actor
 * =====
 *
 * Duh...
 */

export default class Actor extends Phaser.Sprite {

  constructor(whole, x, y, imagedata, count = 1, startAnim = true) {
    super(whole.game, x, y, 'phaser');

    this.whole = whole;
    this.source = imagedata;
    this.count = count;

    Phaser.Sprite.call(this, this.game, x, y, this.source);

    // Set the anchor point so coordinates are relative to the robot feet.
    // this.anchor.set(0.5, 1);
    this.anchor.setTo( 0.5, 0.5);

    this.i96 = {

      id: 'null',

      type: 'actor',

      disarmed: false,

      showMoveAnimation: true,

      isPulating: false,

      level: {
        current: 1,
        max: this.count
      },

      orientation: 'right',

      tweens: {},


      speed: {
        horizontal: {
          current: 0,
          drag: 1.5,
          min: 0,
          max: 200,
          acceleration: 3
        },
        vertical: {
          current: 0,
          drag: 1.5,
          min: -10,
          max: 200,
          acceleration: 3
        }
      },
      went: false,

      animations: []
    };

    //this.i96.animations.push( this.animations.add('walk', [2, 3], 4, true) );
    this.anim_walk = this.animations.add('walk', [0, 1], this.whole.config.playerRunAnimSpeed, true);
    this.play('walk');

    if (startAnim) {
//       this.playAnim('move', true);
    } else {
      this.animations.frame = 1;
    }

  }

  setAnimFrame(frame) {
    this.animations.frame = frame;
  }

  setID(id) {
    this.i96.id = id;
  }

  getID() {
    return this.i96.id;
  }

  update() {
    // TODO: Stub.
  }


}
